/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * The response for the upload request.
 */
export interface UploadResponse {
    /** The ID that returned on Upload operation in blob_id field. */
    blobId: string;
    /** Timeout (in seconds) while upload_uri is valid. */
    timeout: number;
    /** URI to upload the file to. */
    uploadUri: string;
}
